import moment from "moment";
import * as Yup from "yup"
import PriceHelper from "../../helpers/PriceHelper";

export default class EventOption {
    static PRICE_TYPE_FIXED = 'fixed';
    static PRICE_TYPE_PER_DAY = 'per_day';

    id;
    group;
    active = true;
    price = '0,00';
    currency = 'EUR';
    price_type = EventOption.PRICE_TYPE_FIXED;
    max_quantity = 1;
    is_default = false;
    sort_order = 0;
    used = false;
    contents = [];

    // Content in the selected language (form)
    title = '';
    description = '';

    static schema = (params = {}) => {
        let fields = {
            title: Yup.string().required('CMS.Event.option.form.title').max(255, 'CMS.Event.option.form.title|255|max'),
            price: Yup.number().transform((_, value) => parseFloat(String(value).replace(/,/g, '.'))).typeError('CMS.Event.option.form.price|number').required('CMS.Event.option.form.price').min(0, 'CMS.Event.option.form.price|0|number_min'),
            price_type: Yup.string().required('CMS.Event.option.form.price_type')
        };

        if (params.quantity) {
            fields.max_quantity = Yup.number().typeError('CMS.Event.option.form.max_quantity|number').required('CMS.Event.option.form.max_quantity').min(1, 'CMS.Event.option.form.max_quantity|1|number_min');
        }

        return Yup.object(fields);
    }

    static fromJson = (json, language = null) => {
        let item = new EventOption();

        item.id = json.id;
        item.group = json.group;
        item.active = !!json.active;
        item.price = PriceHelper.price(json.price);
        item.price_type = json.price_type;
        item.max_quantity = json.max_quantity || 1;
        item.is_default = !!json.is_default;
        item.sort_order = json.sort_order;
        item.used = !!json.used;
        item.contents = (json.contents || []).map(content => ({ ...content, updated_at: content.updated_at ? moment(content.updated_at) : null }));

        let content = item.getContent(language);
        item.title = content?.title || '';
        item.description = content?.description || '';

        return item;
    }

    getContent = (language = null) => this.contents.filter(content => content.language === language)[0] || this.contents[0];

    priceValue = () => parseFloat(String(this.price).replace(/,/g, '.')) || 0;

    calculatePrice = (period = null, quantity = 1) => {
        let price = this.priceValue() * quantity;

        if (this.price_type === EventOption.PRICE_TYPE_PER_DAY) {
            price *= (period?.nr_days || 1);
        }

        return Math.round(price * 100) / 100;
    }
}
